module.exports = __webpack_public_path__ + "img/MenuButton_LMB.745624a5.jpg";